export default __webpack_public_path__ + "static/media/manbag.a77e3606.jpg";